import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return [
      "source",
      "filterable",
      "noResult"
    ]
  }

  static get values() {
    return {
      noResultLabel: String
    }
  }

  filter() {
    let allItemsHidden = true
    const filterTerm = this.sourceTarget.value

    this.filterableTargets.forEach((el) => {
      const hideItem = !el.innerText
          .toLowerCase()
          .includes(filterTerm.toLowerCase())

      el.hidden = hideItem
      allItemsHidden &&= hideItem
    })

    if (this.hasNoResultTarget) {
      this.noResultTarget.hidden = !allItemsHidden
    }
  }
}
